module.exports = __webpack_public_path__ + "img/pix.373fe869.svg";